import axios from 'axios'
import qs from 'qs'
import {
    authorizationPath
} from '@/request/api.js';


const CODE_OK = 200 // 响应成功的code
const ERR_OK = 300 // 失败
const LOGIN_CODE = 10031
const LOGIN_URL = 'http://view.horsevision.cn/shengangdati/web/index.php?r=home-api/login-wx';

// axios.defaults.withCredentials = true;      // 携带cookie

// http request 请求拦截器
// axios.interceptors.request.use(
//   config => {
//     // if(token){
//     //   config.headers.Authorization = token
//     // }

//     return config
//   },
//   err => Promise.reject(err)
// )

// http response 服务器响应拦截器，这里拦截10405错误，并重新跳入登录页
axios.interceptors.response.use(
    res => {
        const {
            data: {
                code
            }
        } = res
        if (code == LOGIN_CODE) {
            location.href = authorizationPath
            return res
        }

        return res
    },
    err => Promise.reject(err)
)

/**
 * @description get请求
 * @param {String} url 地址
 */
export const $get = (url, params = {}) => {
    return axios.get(url, {
            params
        })
        .then(res => {
            const {
                code,
            } = res.data
            // Promise.resolve是一个方法，将现有的对象转为Promise对象
            if (code === CODE_OK) {
                return Promise.resolve(res.data)
            } else {
                return Promise.reject(res.data)
            }
        })
}

/**
 * @description post请求
 * @param {String} url 地址
 * @param {Object} data 数据
 */
export const $post = (url, data) => {
    return axios.post(url, qs.stringify(data))
        .then(res => {
            const {
                code,
            } = res.data
            if (code === CODE_OK) {
                return Promise.resolve(res.data)
            } else {
                return Promise.reject(res.data)
            }
        })
}

// export const $basicPost = (url, data) => {
//   return axios.post(url, qs.stringify(data))
//   .then(res => {
//     const {error_no, error_info} = res.data

//     if(error_no == CODE_OK){
//       return Promise.resolve(res.data)
//     }else{
//       return Promise.reject(error_info)
//     }
//   })
// }